import { ReactNode } from 'react'
import { Spacer, Text } from '@vinted/web-ui'

type Props = {
  textTheme?: React.ComponentProps<typeof Text>['theme']
  suffixText?: ReactNode
  renderSuffix: () => ReactNode
  badge?: ReactNode
}

const FilterCellSuffix = ({ suffixText, renderSuffix, textTheme, badge }: Props) => {
  return (
    <div className="u-flexbox u-align-items-center">
      {badge}
      {!!suffixText && (
        <span className="filter-cell__suffix-text" data-test-id="selected-filters">
          {badge && <Spacer orientation={Spacer.Orientation.Vertical} as="span" />}
          <Text text={suffixText} theme={textTheme} truncate as="span" />
        </span>
      )}
      {renderSuffix()}
    </div>
  )
}

export default FilterCellSuffix
